export const translations = {
  "fr": {
    "helpCenter.faqTab": "Questions fréquentes",
    "helpCenter.guidesTab": "Guides et SOP",
    "helpCenter.forumTab": "Questions et réponses",
    "sideBar.appLogoAlt": "Prosomo",
    "sideBar.appName": "Prosomo",
    "sideBar.chatAgents": "Chat",
    "sideBar.chatAgentsTitle": "Interface de chat IA",
    "sideBar.chatAgentsSubtitle": "Interagir avec les agents IA",
    "sideBar.dashboard": "Tableau de bord",
    "sideBar.dashboardTitle": "Tableau de bord analytique",
    "sideBar.dashboardSubtitle": "Voir les métriques de performance",
    "sideBar.profile": "Profil",
    "sideBar.profileTitle": "Profil utilisateur",
    "sideBar.profileSubtitle": "Gérer votre compte",
    "sideBar.widgets": "Widgets",
    "sideBar.widgetsTitle": "Widgets personnalisés",
    "sideBar.widgetsSubtitle": "Créer et gérer des widgets",
    "sideBar.settings": "Paramètres",
    "sideBar.settingsTitle": "Paramètres de l'application",
    "sideBar.settingsSubtitle": "Configurer vos préférences",
    "sideBar.aiAgents": "Agents IA",
    "sideBar.aiAgentsTitle": "Gestion des agents IA",
    "sideBar.aiAgentsSubtitle": "Gérer les configurations des agents IA",
    "sideBar.teamManagement": "Gestion des équipes",
    "sideBar.teamManagementTitle": "Gestion des équipes",
    "sideBar.teamManagementSubtitle": "Administrer les paramètres des équipes",
    "sideBar.helpCenter": "Centre d'aide",
    "sideBar.helpCenterTitle": "Centre d'aide",
    "sideBar.helpCenterSubtitle": "Obtenir du support et des ressources",
    "sideBar.technicalSupport": "Support Technique",
    "sideBar.needHelp": "Besoin d'aide ?",
    "sideBar.contactSupport": "Contacter le support",
    "sideBar.roleLabel": "Rôle :",
    "sideBar.idLabel": "ID :",
    "topBar.darkMode": "Mode Sombre",
    "topBar.lightMode": "Mode Clair",
    "topBar.userAvatarAlt": "Utilisateur",
    "topBar.profile": "Profil",
    "topBar.logout": "Déconnexion",
    "profilePage.profile": "Profil",
    "profilePage.subtitle": "Gérez vos informations personnelles",
    "profilePage.personalInformation": "Informations personnelles",
    "profilePage.editProfile": "Modifier le profil",
    "profilePage.profilePicture": "Photo de profil",
    "profilePage.uploadImage": "Télécharger une image",
    "profilePage.fullName": "Nom complet",
    "profilePage.email": "Courriel",
    "profilePage.language": "Langue",
    "profilePage.french": "Français",
    "profilePage.english": "Anglais",
    "profilePage.cancel": "Annuler",
    "profilePage.save": "Enregistrer",
    "profilePage.na": "N/D",
    "profilePage.profilePictureAlt": "Profil",
    "profilePage.invalidImageFile": "Veuillez sélectionner un fichier image valide (PNG, JPG, GIF ou WebP)",
    "profilePage.imageSizeTooLarge": "L'image doit être inférieure à 5 Mo",
    "profilePage.imageUrlError": "Échec de l'obtention de l'URL publique pour l'image téléchargée",
    "profilePage.uploadImageError": "Erreur lors du téléchargement de l'image de profil",
    "profilePage.profileUpdated": "Profil mis à jour avec succès",
    "profilePage.updateProfileError": "Erreur lors de la mise à jour du profil",
    "settings.generalPreferences": "Préférences générales",
    "settings.language": "Langue",
    "settings.french": "Français",
    "settings.english": "Anglais",
    "settings.save": "Enregistrer",
    "settings.platformManagement": "Gestion de la plateforme",
    "settings.bucketError": "Les compartiments de stockage ne sont pas bien configurés. Le téléchargement d'images pourrait ne pas fonctionner.",
    "settings.appLogo": "Logo de l'application",
    "settings.appLogoAlt": "Logo de l'application",
    "settings.appLogoDescription": "Mettez à jour le logo de l'application qui apparaît dans la barre latérale et sur toute la plateforme. Pour de meilleurs résultats, utilisez une image carrée (ratio 1:1) avec des dimensions d'au moins 200x200 pixels.",
    "settings.uploadNewLogo": "Télécharger un nouveau logo",
    "settings.logoChangeNote": "Les modifications s'appliqueront immédiatement après le téléchargement",
    "settings.defaultRequestEmail": "Email de demande par défaut",
    "settings.defaultRequestEmailDescription": "Définissez l'adresse email par défaut où les demandes des utilisateurs seront envoyées lorsqu'aucun email spécifique à un agent n'est configuré.",
    "settings.emailPlaceholder": "support@example.com",
    "settings.aiAgentImages": "Images des agents IA",
    "settings.aiAgentImagesNote": "💡 <strong>Les images des agents IA sont maintenant gérées dans la section Gestion des agents IA.</strong><br />Accédez à l'onglet \"Agents IA\" pour télécharger et gérer les images pour chaque agent individuel.",
    "settings.appInfo": "À propos de l'application",
    "settings.version": "Version : 1.0.0",
    "settings.platformDescription": "Plateforme IA interne pour employés",
    "settings.developedWith": "Développé avec React & Vite",
    "settings.cancel": "Annuler",
    "settings.edit": "Modifier",
    "settings.languageUpdated": "Langue mise à jour avec succès !",
    "settings.languageUpdateError": "Erreur lors de la mise à jour de la langue",
    "settings.invalidImageFile": "Veuillez sélectionner un fichier image (PNG, JPG, GIF ou WebP)",
    "settings.imageSizeTooLarge": "L'image doit être inférieure à 5 Mo",
    "settings.imageUrlError": "Échec de l'obtention de l'URL publique pour le fichier téléchargé",
    "settings.logoUpdated": "Logo mis à jour avec succès !",
    "settings.logoUploadError": "Erreur lors du téléchargement du logo",
    "settings.invalidEmail": "Veuillez entrer une adresse email valide",
    "settings.emailUpdated": "Email de demande par défaut mis à jour avec succès !",
    "settings.emailUpdateError": "Erreur lors de la mise à jour de l'email",
    "statistics.unknownUser": "Utilisateur inconnu",
    "statistics.latestQuestionsError": "Échec du chargement des dernières questions",
    "statistics.analyticsError": "Échec du chargement des données analytiques",
    "statistics.loadingAnalytics": "Chargement des analyses...",
    "statistics.allTeams": "Toutes les équipes",
    "statistics.filters": "Filtres",
    "statistics.clear": "Effacer",
    "statistics.filterByAgents": "Filtrer par agents",
    "statistics.searchUsers": "Rechercher des utilisateurs",
    "statistics.searchUsersPlaceholder": "Rechercher par nom d'utilisateur...",
    "statistics.totalMessages": "Total des messages (mois sélectionné)",
    "statistics.teamMessages": "Messages d'équipe (mois sélectionné)",
    "statistics.allTeamsMessages": "Messages de toutes les équipes",
    "statistics.dailyMessages": "Messages quotidiens",
    "statistics.messages": "Messages",
    "statistics.topAgents": "Agents IA les plus utilisés",
    "statistics.unknownAgent": "Agent {id}",
    "statistics.messagesCount": "{count} messages",
    "statistics.noAgentData": "Aucune donnée d'agent pour la période sélectionnée",
    "statistics.recentChats": "Conversations récentes",
    "statistics.noRecentChats": "Aucune conversation récente dans la période sélectionnée",
    "statistics.latestQuestions": "Dernières questions posées",
    "statistics.loadingQuestions": "Chargement des dernières questions...",
    "statistics.noRecentQuestions": "Aucune question récente pour le moment",
    "statistics.user": "Utilisateur",
    "statistics.agent": "Agent",
    "statistics.time": "Heure",
    "statistics.status": "Statut",
    "statistics.statusCompleted": "Terminé",
    "teamManagement.accessDenied": "Accès refusé",
    "teamManagement.accessDeniedMessage": "Vous n'avez pas la permission d'accéder à la page de gestion des équipes. Seuls les utilisateurs ayant le rôle d'administrateur peuvent accéder à cette page.",
    "teamManagement.currentRole": "Rôle actuel :",
    "teamManagement.unknownRole": "Inconnu",
    "teamManagement.refreshPermissions": "Rafraîchir les permissions",
    "teamManagement.title": "Gestion des équipes",
    "teamManagement.subtitle": "Créez une nouvelle équipe ou sélectionnez une équipe existante pour gérer les membres et les paramètres. En tant qu'administrateur, vous pouvez également gérer tous les utilisateurs et leurs rôles.",
    "teamManagement.createNewTeam": "Créer une équipe",
    "teamManagement.inviteUser": "Inviter un utilisateur",
    "teamManagement.teams": "Équipes",
    "teamManagement.loadingTeams": "Chargement des équipes...",
    "teamManagement.noTeams": "Aucune équipe créée pour l'instant",
    "teamManagement.createTeamTitle": "Créer une nouvelle équipe",
    "teamManagement.teamName": "Nom de l'équipe",
    "teamManagement.description": "Description",
    "teamManagement.allowedAgents": "Agents IA autorisés",
    "teamManagement.cancel": "Annuler",
    "teamManagement.createTeam": "Créer une équipe",
    "teamManagement.inviteUserTitle": "Inviter un nouvel utilisateur",
    "teamManagement.fullName": "Nom complet *",
    "teamManagement.fullNamePlaceholder": "John Doe",
    "teamManagement.emailAddress": "Adresse email *",
    "teamManagement.emailPlaceholder": "john.doe@example.com",
    "teamManagement.role": "Rôle",
    "teamManagement.assignToTeams": "Assigner aux équipes * (Sélectionnez au moins une)",
    "teamManagement.noTeamsForInvite": "⚠️ Vous devez créer au moins une équipe avant d'inviter des utilisateurs",
    "teamManagement.sendInvitation": "Envoyer l'invitation",
    "teamManagement.editUserTitle": "Modifier l'utilisateur : {name}",
    "teamManagement.teamMemberships": "Adhésions aux équipes",
    "teamManagement.roleChangeWarning": "⚠️ Changer votre propre rôle peut affecter votre accès à certaines fonctionnalités",
    "teamManagement.updateUser": "Mettre à jour l'utilisateur",
    "teamManagement.addMembersTitle": "Ajouter des membres à {name}",
    "teamManagement.searchUsersPlaceholder": "Rechercher des utilisateurs par nom ou email...",
    "teamManagement.noUsersFound": "Aucun utilisateur trouvé correspondant à votre recherche ou tous les utilisateurs sont déjà dans cette équipe",
    "teamManagement.userAvatarAlt": "{name}",
    "teamManagement.addToTeam": "Ajouter à l'équipe",
    "teamManagement.manageTeamTitle": "Gérer l'équipe : {name}",
    "teamManagement.teamMembers": "Membres de l'équipe",
    "teamManagement.allUsers": "Tous les utilisateurs",
    "teamManagement.allUsersDescription": "Gérer tous les utilisateurs du système",
    "teamManagement.inviteNewUser": "Inviter un nouvel utilisateur",
    "teamManagement.actions": "Actions",
    "teamManagement.user": "Utilisateur",
    "teamManagement.created": "Créé",
    "teamManagement.editTeam": "Modifier l'équipe",
    "teamManagement.addMember": "Ajouter un membre",
    "teamManagement.deleteTeam": "Supprimer l'équipe",
    "teamManagement.removeFromTeam": "Retirer de l'équipe",
    "teamManagement.memberAvatarAlt": "{name}",
    "teamManagement.loadingTeamMembers": "Chargement des membres de l'équipe...",
    "teamManagement.noMembers": "Aucun membre dans cette équipe",
    "teamManagement.invitePrompt": "Utilisez le bouton d'invitation ci-dessus pour ajouter des utilisateurs",
    "teamManagement.accountInformation": "Informations du compte",
    "teamManagement.email": "Email",
    "teamManagement.language": "Langue",
    "teamManagement.french": "Français",
    "teamManagement.english": "Anglais",
    "teamManagement.na": "N/D",
    "teamManagement.administrator": "Administrateur",
    "teamManagement.teamMember": "Membre de l'équipe",
    "teamManagement.invitationIdError": "Échec de la génération d'un ID d'invitation unique après plusieurs tentatives",
    "teamManagement.loadDataError": "Erreur lors du chargement des données",
    "teamManagement.loadTeamMembersError": "Erreur lors du chargement des membres de l'équipe",
    "teamManagement.loadTeamDetailsError": "Erreur lors du chargement des détails de l'équipe",
    "teamManagement.loadUserDetailsError": "Erreur lors du chargement des détails de l'utilisateur",
    "teamManagement.userUpdated": "Utilisateur mis à jour avec succès",
    "teamManagement.updateUserError": "Erreur lors de la mise à jour de l'utilisateur",
    "teamManagement.teamCreated": "Équipe créée avec succès",
    "teamManagement.createTeamError": "Erreur lors de la création de l'équipe",
    "teamManagement.teamUpdated": "Équipe mise à jour avec succès",
    "teamManagement.updateTeamError": "Erreur lors de la mise à jour de l'équipe",
    "teamManagement.teamDeleted": "Équipe supprimée avec succès",
    "teamManagement.deleteTeamError": "Erreur lors de la suppression de l'équipe",
    "teamManagement.inviteFormError": "Nom complet, email et au moins une équipe sont requis",
    "teamManagement.invitationSuccess": "Invitation envoyée avec succès à {fullName} ({email}) ! L'utilisateur recevra un email avec :\n• Instructions de connexion à la plateforme\n• Accès à {teamCount} équipe(s) : {teamNames}\n• Assignation de rôle : {role}\nLe compte utilisateur sera créé automatiquement lorsqu'il acceptera l'invitation.",
    "teamManagement.invitationError": "Échec de l'envoi de l'invitation. ",
    "teamManagement.invitationIdErrorDetails": "Impossible de générer un ID d'invitation unique. Veuillez réessayer.",
    "teamManagement.networkError": "Une erreur réseau s'est produite. Veuillez vérifier votre connexion et réessayer.",
    "teamManagement.serviceUnavailable": "Le service d'invitation est temporairement indisponible. Veuillez réessayer plus tard.",
    "teamManagement.unknownError": "Une erreur inconnue s'est produite.",
    "teamManagement.userAlreadyInTeam": "L'utilisateur est déjà membre de cette équipe",
    "teamManagement.userAddedToTeam": "Utilisateur ajouté à l'équipe avec succès",
    "teamManagement.addUserToTeamError": "Erreur lors de l'ajout de l'utilisateur à l'équipe",
    "teamManagement.removeUserConfirm": "Êtes-vous sûr de vouloir retirer cet utilisateur de l'équipe ?",
    "teamManagement.userRemovedFromTeam": "Utilisateur retiré de l'équipe avec succès",
    "teamManagement.removeUserError": "Erreur lors du retrait de l'utilisateur de l'équipe",
    "teamManagement.deleteTeamConfirm": "Êtes-vous sûr de vouloir supprimer cette équipe ? Cette action ne peut pas être annulée.",
    "teamManagement.updateTeam": "Mettre à jour l'équipe",
    "widgets.embedCode.title": "Intégrer le widget : {name}",
    "widgets.embedCode.description": "Copiez ce code et collez-le dans le HTML de votre site web, juste avant la balise de fermeture <code>&lt;/body&gt;</code>.",
    "widgets.embedCode.copied": "Copié !",
    "widgets.embedCode.copyToClipboard": "Copier dans le presse-papiers",
    "widgets.embedCode.copySuccess": "Code d'intégration du widget copié dans le presse-papiers",
    "widgets.embedCode.installationNotes": "Notes d'installation :",
    "widgets.embedCode.positionNote": "Le widget apparaîtra comme un bouton de chat dans le coin {position} de votre site web.",
    "widgets.embedCode.interactionNote": "Les utilisateurs peuvent cliquer sur le bouton pour ouvrir l'interface de chat.",
    "widgets.embedCode.autoOpenNote": "Le widget s'ouvrira automatiquement après {delay} secondes si activé.",
    "widgets.embedCode.important": "Important :",
    "widgets.embedCode.allowedOriginsNote": "Ce widget ne fonctionnera que sur les domaines suivants :",
    "widgets.preview.title": "Aperçu du Widget",
    "widgets.preview.headerTitle": "Site Web Exemple",
    "widgets.preview.navHome": "Accueil",
    "widgets.preview.navAbout": "À propos",
    "widgets.preview.navServices": "Services",
    "widgets.preview.navContact": "Contact",
    "widgets.preview.mainTitle": "Bienvenue sur Notre Site Web",
    "widgets.preview.mainContent": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    "widgets.preview.featureOneTitle": "Fonctionnalité Une",
    "widgets.preview.featureOneContent": "Découvrez nos solutions innovantes conçues pour vous aider à atteindre vos objectifs de manière efficace et performante.",
    "widgets.preview.featureTwoTitle": "Fonctionnalité Deux",
    "widgets.preview.featureTwoContent": "Profitez d'une intégration fluide avec notre technologie de pointe pour une expérience utilisateur optimale.",
    "widgets.preview.footerText": "&copy; 2025 Site Web Exemple. Tous droits réservés.",
    "widgets.preview.footerPrivacy": "Politique de Confidentialité",
    "widgets.preview.footerTerms": "Conditions de Service",
    "widgets.widgetForm.basicSettings": "Paramètres de base",
    "widgets.widgetForm.widgetName": "Nom du widget *",
    "widgets.widgetForm.widgetNamePlaceholder": "Chat de support client",
    "widgets.widgetForm.integrationType": "Type d'intégration",
    "widgets.widgetForm.aiAgent": "Agent IA",
    "widgets.widgetForm.customWebhook": "Webhook personnalisé",
    "widgets.widgetForm.webhookUrl": "URL du webhook *",
    "widgets.widgetForm.webhookUrlPlaceholder": "https://votre-endpoint-webhook.com",
    "widgets.widgetForm.webhookRoute": "Route du webhook",
    "widgets.widgetForm.webhookRoutePlaceholder": "général",
    "widgets.widgetForm.isActive": "Actif",
    "widgets.widgetForm.isActiveDescription": "Lorsqu'il est inactif, le widget ne sera accessible sur aucun site web.",
    "widgets.widgetForm.allowedOrigins": "Origines autorisées",
    "widgets.widgetForm.allowedOriginsDescription": "Spécifiez quels sites web peuvent utiliser ce widget. Laissez vide pour autoriser toutes les origines.",
    "widgets.widgetForm.originPlaceholder": "https://exemple.com",
    "widgets.widgetForm.removeOrigin": "Supprimer l'origine",
    "widgets.widgetForm.addOrigin": "Ajouter une origine",
    "widgets.widgetForm.appearance": "Apparence",
    "widgets.widgetForm.agentName": "Nom de l'agent",
    "widgets.widgetForm.position": "Position",
    "widgets.widgetForm.positionBottomRight": "Bas à droite",
    "widgets.widgetForm.positionBottomLeft": "Bas à gauche",
    "widgets.widgetForm.positionTopRight": "Haut à droite",
    "widgets.widgetForm.positionTopLeft": "Haut à gauche",
    "widgets.widgetForm.primaryColor": "Couleur principale",
    "widgets.widgetForm.autoOpenDelay": "Délai d'ouverture automatique (secondes)",
    "widgets.widgetForm.autoOpenDelayDescription": "Temps en secondes avant que le chat ne s'ouvre automatiquement. Définissez à 0 pour désactiver.",
    "widgets.widgetForm.agentImageUrl": "URL de l'image de l'agent",
    "widgets.widgetForm.agentImagePlaceholder": "https://exemple.com/image.jpg",
    "widgets.widgetForm.agentImageDescription": "URL de l'image de l'avatar de l'agent (taille recommandée : 200x200px)",
    "widgets.widgetForm.agentImageAlt": "Agent",
    "widgets.widgetForm.welcomeMessage": "Message de bienvenue",
    "widgets.widgetForm.firstMessage": "Premier message",
    "widgets.widgetForm.language": "Langue",
    "widgets.widgetForm.french": "Français",
    "widgets.widgetForm.english": "Anglais",
    "widgets.widgetForm.cancel": "Annuler",
    "widgets.widgetForm.updateWidget": "Mettre à jour le widget",
    "widgets.widgetForm.createWidget": "Créer un widget",
    "widgets.widgetForm.selectAgent": "Sélectionner un agent",
    "widgets.widgetForm.welcomeMessageDefault": "Comment puis-je vous aider aujourd'hui ?",
    "widgets.widgetForm.agentNameDefault": "Assistant IA",
    "widgets.widgetForm.firstMessageDefault": "Je suis un agent IA pour vous aider à trouver ce que vous cherchez !",
    "widgets.widgetForm.selectAgentError": "Veuillez sélectionner un agent",
    "widgets.widgetForm.updateSuccess": "Widget mis à jour avec succès",
    "widgets.widgetForm.createSuccess": "Widget créé avec succès",
    "widgets.widgetForm.saveError": "Échec de l'enregistrement du widget.",
    "widgets.title": "Widgets de chat",
    "widgets.subtitle": "Créer et gérer des widgets de chat pour votre site web",
    "widgets.createWidget": "Créer un widget",
    "widgets.actions": "Actions",
    "widgets.name": "Nom",
    "widgets.agent": "Agent",
    "widgets.status": "Statut",
    "widgets.allowedOrigins": "Origines autorisées",
    "widgets.themePreview": "Aperçu du thème",
    "widgets.loadingWidgets": "Chargement des widgets...",
    "widgets.noWidgets": "Aucun widget trouvé. Cliquez sur \"Créer un widget\" pour commencer.",
    "widgets.customWebhook": "Webhook personnalisé",
    "widgets.allOrigins": "Toutes les origines",
    "widgets.loadError": "Échec du chargement des widgets. Veuillez réessayer plus tard.",
    "widgets.toggleStatusError": "Échec de la mise à jour du statut du widget. Veuillez réessayer.",
    "widgets.activated": "Widget activé",
    "widgets.deactivated": "Widget désactivé",
    "widgets.deleteSuccess": "Widget supprimé avec succès",
    "widgets.deleteError": "Échec de la suppression du widget. Veuillez réessayer.",
    "widgets.deleteConfirm": "Êtes-vous sûr de vouloir supprimer ce widget ? Cette action ne peut pas être annulée.",
    "widgets.moreActions": "Plus d'actions",
    "widgets.copyEmbedCode": "Copier le code d'intégration",
    "widgets.deactivate": "Désactiver",
    "widgets.activate": "Activer",
    "widgets.editWidget": "Modifier le widget",
    "widgets.deleteWidget": "Supprimer le widget",
    "agents.aiAssistant": "Assistant IA",
    "agents.statusOnline": "En ligne",
    "agents.noAgentsAvailable": "Aucun agent IA disponible",
    "agents.noAgentsMessage": "Aucun agent IA n'est disponible pour cette équipe. Contactez votre administrateur pour obtenir un accès.",
    "agentsManagement.title": "Gestion des agents IA",
    "agentsManagement.subtitle": "Créez, modifiez et gérez les agents IA pour votre organisation",
    "agentsManagement.addNewAgent": "Ajouter un nouvel agent",
    "agentsManagement.searchAgentsPlaceholder": "Rechercher des agents...",
    "agentsManagement.allTeams": "Toutes les équipes",
    "agentsManagement.loadingAgents": "Chargement des agents...",
    "agentsManagement.noAgentsCreated": "Aucun agent IA créé pour le moment",
    "agentsManagement.noAgentsFound": "Aucun agent trouvé",
    "agentsManagement.createFirstAgentMessage": "Créez votre premier agent IA pour commencer.",
    "agentsManagement.adjustSearchCriteria": "Essayez d'ajuster vos critères de recherche.",
    "agentsManagement.totalAgents": "Total des agents",
    "agentsManagement.activeAgents": "Agents actifs",
    "agentsManagement.teams": "Équipes",
    "agentsManagement.accessDeniedTitle": "Accès refusé",
    "agentsManagement.accessDeniedMessage": "Vous n'avez pas la permission de gérer les agents IA.",
    "agentsManagement.addNewAgentTitle": "Ajouter un nouvel agent IA",
    "agentsManagement.editAgentTitle": "Modifier l'agent",
    "agentsManagement.agentIdLabel": "Identifiant de l'agent *",
    "agentsManagement.agentIdPlaceholder": "identifiant-agent (généré automatiquement à partir du nom si vide)",
    "agentsManagement.agentNameLabel": "Nom de l'agent *",
    "agentsManagement.agentNamePlaceholder": "p. ex. Assistant aux ventes",
    "agentsManagement.descriptionLabel": "Description",
    "agentsManagement.descriptionPlaceholder": "Décrivez ce que fait cet agent...",
    "agentsManagement.apiEndpointLabel": "Point de terminaison API *",
    "agentsManagement.apiEndpointPlaceholder": "p. ex. api/agents/assistant-ventes",
    "agentsManagement.requestEmailLabel": "Courriel de demande",
    "agentsManagement.requestEmailPlaceholder": "specifique-agent@exemple.com",
    "agentsManagement.requestEmailDescription": "Adresse courriel pour les demandes des utilisateurs liées à cet agent. Si non spécifié, le courriel par défaut sera utilisé.",
    "agentsManagement.teamAssignmentLabel": "Affectation à une équipe",
    "agentsManagement.selectTeam": "Sélectionner une équipe",
    "agentsManagement.agentImageLabel": "Image de l'agent",
    "agentsManagement.agentPreviewAlt": "Aperçu de l'agent",
    "agentsManagement.uploadImage": "Téléverser une image",
    "agentsManagement.setActiveLabel": "Activer l'agent immédiatement",
    "agentsManagement.setActiveDescription": "Si non coché, l'agent sera créé en mode « En formation »",
    "agentsManagement.cancel": "Annuler",
    "agentsManagement.createAgent": "Créer l'agent",
    "agentsManagement.updateAgent": "Mettre à jour l'agent",
    "agentsManagement.defaultAgentsCreated": "Agents par défaut créés avec succès",
    "agentsManagement.failedToCreateDefaultAgents": "Échec de la création des agents par défaut",
    "agentsManagement.errorFetchingAgents": "Erreur lors de la récupération des agents",
    "agentsManagement.invalidImageFile": "Veuillez sélectionner un fichier image valide (PNG, JPG, GIF ou WebP)",
    "agentsManagement.imageSizeTooLarge": "L'image doit être inférieure à 5 Mo",
    "agentsManagement.requiredFieldsMissing": "Le nom et le point de terminaison API sont requis",
    "agentsManagement.agentCreated": "Agent créé avec succès",
    "agentsManagement.errorCreatingAgent": "Erreur lors de la création de l'agent",
    "agentsManagement.agentUpdated": "Agent mis à jour avec succès",
    "agentsManagement.errorUpdatingAgent": "Erreur lors de la mise à jour de l'agent",
    "agentsManagement.deleteAgentConfirm": "Êtes-vous sûr de vouloir supprimer cet agent ? Cette action ne peut pas être annulée.",
    "agentsManagement.agentDeleted": "Agent supprimé avec succès",
    "agentsManagement.errorDeletingAgent": "Erreur lors de la suppression de l'agent",
    "agentsManagement.statusActive": "Actif",
    "agentsManagement.statusInactive": "Inactif",
    "agentsManagement.noDescription": "Aucune description fournie",
    "agentsManagement.createdAt": "Créé",
    "agentsManagement.editAgent": "Modifier l'agent",
    "agentsManagement.deleteAgent": "Supprimer l'agent",
    "agentsManagement.noAssignedTeams": "Aucune équipe assignée",
    "auth.resetEmailSent": "Vérifiez votre boîte de réception pour un lien de réinitialisation de mot de passe.",
    "auth.passwordsDoNotMatch": "Les mots de passe ne correspondent pas",
    "auth.registerSuccess": "Merci de vous être inscrit ! Veuillez vérifier votre boîte de réception et cliquer sur le lien pour vérifier votre courriel.",
    "auth.forgotPassword": "Mot de passe oublié",
    "auth.register": "S'inscrire",
    "auth.login": "Connexion",
    "auth.fullName": "Nom complet",
    "auth.email": "Courriel",
    "auth.password": "Mot de passe",
    "auth.confirmPassword": "Confirmer le mot de passe",
    "auth.forgotPasswordLink": "Mot de passe oublié ?",
    "auth.backToLogin": "Retour à la connexion",
    "auth.sendResetLink": "Envoyer le lien de réinitialisation",
    "auth.signIn": "Se connecter",
    "auth.alreadyHaveAccount": "Vous avez déjà un compte ? Connectez-vous",
    "auth.dontHaveAccount": "Pas de compte ? Inscrivez-vous",
    "auth.changePassword": "Modifier mon mot de passe",
    "auth.newPassword": "Nouveau mot de passe",
    "auth.updateDescription": "Entrez votre nouveau mot de passe. Il doit contenir 8 à 15 caractères alphanumériques avec au moins un caractère spécial.",
    "auth.cancel": "Annuler",
    "auth.updatePassword": "Mettre à jour le mot de passe",
    "auth.invalidPasswordLength": "Le mot de passe doit contenir entre 8 et 15 caractères.",
    "auth.invalidPasswordFormat": "Le mot de passe doit être alphanumérique et contenir au moins un caractère spécial.",
    "auth.passwordUpdated": "Votre mot de passe a été mis à jour avec succès.",
    "auth.recoveryDetected": "Veuillez définir un nouveau mot de passe.",    
    "chatInterface.welcome": "Bienvenue sur",
    "chatInterface.howCanIHelp": "Comment puis-je vous aider aujourd'hui ?",
    "chatInterface.typing": "En train de taper...",
    "chatInterface.online": "En ligne",
    "chatInterface.agentDetails": "Détails de l'agent",
    "chatInterface.hideDetails": "Masquer les détails",
    "chatInterface.showDetails": "Afficher les détails",
    "chatInterface.resetConversation": "Réinitialiser la conversation",
    "chatInterface.reset": "Réinitialiser",
    "chatInterface.sessionIdLabel": "ID de session :",
    "chatInterface.descriptionLabel": "Description :",
    "chatInterface.teamAssignmentLabel": "Assignation à une équipe :",
    "chatInterface.availableToAllTeams": "Disponible pour toutes les équipes",
    "chatInterface.webhookLabel": "Webhook :",
    "chatInterface.noDescription": "Aucune description fournie",
    "chatInterface.responseProcessingError": "Réponse reçue impossible à traiter.",
    "chatInterface.technicalDifficulty": "Désolé, je rencontre des difficultés techniques. Veuillez réessayer.",
    "chatInterface.copyResponse": "Copier la réponse",
    "chatInterface.jumpToLatest": "Aller au dernier message",
    "chatInterface.sendRequestTitle": "Envoyer une demande",
    "chatInterface.requestSentSuccess": "Demande envoyée avec succès !",
    "chatInterface.requestSentMessage": "Nous avons reçu votre demande et vous répondrons bientôt.",
    "chatInterface.yourNameLabel": "Votre nom",
    "chatInterface.yourEmailLabel": "Votre email *",
    "chatInterface.emailRequired": "L'email est requis",
    "chatInterface.invalidEmail": "Veuillez entrer un email valide",
    "chatInterface.subjectLabel": "Sujet *",
    "chatInterface.subjectRequired": "Le sujet est requis",
    "chatInterface.messageLabel": "Message *",
    "chatInterface.messageRequired": "Le message est requis",
    "chatInterface.attachmentsLabel": "Pièces jointes (facultatif, max 10 Mo au total)",
    "chatInterface.attachFiles": "Joindre des fichiers",
    "chatInterface.filesSelected": "{count} fichier(s) sélectionné(s)",
    "chatInterface.attachmentsSizeError": "La taille totale des fichiers ne peut pas dépasser 10 Mo",
    "chatInterface.sendRequest": "Envoyer la demande",
    "chatInterface.request": "Demande",
    "chatInterface.typeMessage": "Tapez votre message...",
    "chatInterface.send": "Envoyer",
    "chatInterface.requestSubmitted": "Demande envoyée le {date}. Une copie a été envoyée à {email}.",
    "chatInterface.copyButton": "Copier",
    "chatInterface.copiedButton": "Copié !",
    "guards.checkingPermissions": "Vérification des permissions...",
    "guards.accessDeniedTitle": "Accès refusé",
    "guards.accessDeniedMessage": "Vous n'avez pas la permission d'accéder à ce contenu.",
    "guards.currentRoleLabel": "Rôle actuel :",
    "guards.requiredPermissionLabel": "Permission requise :",
    "guards.requiredPageAccessLabel": "Accès à la page requis :",
    "guards.refreshing": "Rafraîchissement...",
    "guards.refreshPermissions": "Rafraîchir les permissions",
    "helpCenter.faqSection.title": "Questions Fréquemment Posées",
    "helpCenter.faqSection.failedToLoad": "Échec du chargement des FAQ. Veuillez réessayer plus tard.",
    "helpCenter.faqSection.deleteConfirm": "Êtes-vous sûr de vouloir supprimer cette FAQ ?",
    "helpCenter.faqSection.deleteSuccess": "FAQ supprimée avec succès.",
    "helpCenter.faqSection.deleteFailed": "Échec de la suppression de la FAQ. Veuillez réessayer.",
    "helpCenter.faqSection.requiredFields": "Le titre et le contenu sont requis.",
    "helpCenter.faqSection.updateSuccess": "FAQ mise à jour avec succès.",
    "helpCenter.faqSection.createSuccess": "FAQ créée avec succès.",
    "helpCenter.faqSection.saveFailed": "Échec de l'enregistrement de la FAQ. Veuillez réessayer.",
    "helpCenter.faqSection.addFaq": "Ajouter une FAQ",
    "helpCenter.faqSection.editFaqTitle": "Modifier la FAQ",
    "helpCenter.faqSection.addFaqTitle": "Ajouter une nouvelle FAQ",
    "helpCenter.faqSection.questionLabel": "Question",
    "helpCenter.faqSection.questionPlaceholder": "Entrez la question",
    "helpCenter.faqSection.answerLabel": "Réponse",
    "helpCenter.faqSection.answerPlaceholder": "Entrez la réponse",
    "helpCenter.faqSection.noFaqs": "Aucune FAQ trouvée.",
    "helpCenter.faqSection.addFaqPrompt": "Cliquez sur le bouton \"Ajouter une FAQ\" pour en créer une.",
    "helpCenter.forumSection.title": "Questions & Réponses",
    "helpCenter.forumSection.failedToLoad": "Échec du chargement des questions. Veuillez réessayer plus tard.",
    "helpCenter.forumSection.requiredFields": "Le titre et le contenu sont requis.",
    "helpCenter.forumSection.submitSuccess": "Votre question a été soumise avec succès.",
    "helpCenter.forumSection.submitFailed": "Échec de la soumission de la question. Veuillez réessayer.",
    "helpCenter.forumSection.answerRequired": "La réponse est requise.",
    "helpCenter.forumSection.answerSuccess": "Réponse soumise avec succès.",
    "helpCenter.forumSection.answerFailed": "Échec de la soumission de la réponse. Veuillez réessayer.",
    "helpCenter.forumSection.editQuestionSuccess": "Question mise à jour avec succès.",
    "helpCenter.forumSection.editQuestionFailed": "Échec de la modification de la question. Veuillez réessayer.",
    "helpCenter.forumSection.deleteQuestionConfirm": "Êtes-vous sûr de vouloir supprimer cette question ?",
    "helpCenter.forumSection.deleteQuestionSuccess": "Question supprimée avec succès.",
    "helpCenter.forumSection.deleteQuestionFailed": "Échec de la suppression de la question. Veuillez réessayer.",
    "helpCenter.forumSection.editAnswerSuccess": "Réponse mise à jour avec succès.",
    "helpCenter.forumSection.editAnswerFailed": "Échec de la modification de la réponse. Veuillez réessayer.",
    "helpCenter.forumSection.deleteAnswerConfirm": "Êtes-vous sûr de vouloir supprimer cette réponse ?",
    "helpCenter.forumSection.deleteAnswerSuccess": "Réponse supprimée avec succès.",
    "helpCenter.forumSection.deleteAnswerFailed": "Échec de la suppression de la réponse. Veuillez réessayer.",
    "helpCenter.forumSection.askQuestion": "Poser une question",
    "helpCenter.forumSection.newQuestionTitle": "Poser une nouvelle question",
    "helpCenter.forumSection.titleLabel": "Titre *",
    "helpCenter.forumSection.titlePlaceholder": "Résumez votre question",
    "helpCenter.forumSection.contentLabel": "Détails de la question *",
    "helpCenter.forumSection.contentPlaceholder": "Fournissez des détails sur votre question",
    "helpCenter.forumSection.submitQuestion": "Soumettre la question",
    "helpCenter.forumSection.editQuestionTitle": "Modifier la question",
    "helpCenter.forumSection.saveChanges": "Enregistrer les modifications",
    "helpCenter.forumSection.noQuestions": "Aucune question trouvée. Soyez le premier à poser une question !",
    "helpCenter.forumSection.statusAnswered": "Répondu",
    "helpCenter.forumSection.statusOpen": "Ouvert",
    "helpCenter.forumSection.answerFrom": "Réponse de :",
    "helpCenter.forumSection.admin": "Administrateur",
    "helpCenter.forumSection.answerLabel": "Votre réponse *",
    "helpCenter.forumSection.answerPlaceholder": "Tapez votre réponse ici...",
    "helpCenter.forumSection.answerQuestion": "Répondre à cette question",
    "helpCenter.guidesSection.title": "Guides & SOPs",
    "helpCenter.guidesSection.failedToLoad": "Échec du chargement des guides. Veuillez réessayer plus tard.",
    "helpCenter.guidesSection.deleteConfirm": "Êtes-vous sûr de vouloir supprimer ce guide ?",
    "helpCenter.guidesSection.deleteSuccess": "Guide supprimé avec succès.",
    "helpCenter.guidesSection.deleteFailed": "Échec de la suppression du guide. Veuillez réessayer.",
    "helpCenter.guidesSection.titleRequired": "Le titre est requis.",
    "helpCenter.guidesSection.updateSuccess": "Guide mis à jour avec succès.",
    "helpCenter.guidesSection.createSuccess": "Guide créé avec succès.",
    "helpCenter.guidesSection.saveFailed": "Échec de l'enregistrement du guide. Veuillez réessayer.",
    "helpCenter.guidesSection.addGuide": "Ajouter un guide",
    "helpCenter.guidesSection.editGuideTitle": "Modifier le guide",
    "helpCenter.guidesSection.addGuideTitle": "Ajouter un nouveau guide",
    "helpCenter.guidesSection.titleLabel": "Titre *",
    "helpCenter.guidesSection.titlePlaceholder": "Entrez le titre du guide",
    "helpCenter.guidesSection.descriptionLabel": "Description",
    "helpCenter.guidesSection.descriptionPlaceholder": "Entrez une brève description",
    "helpCenter.guidesSection.externalLinkLabel": "Lien externe",
    "helpCenter.guidesSection.urlPlaceholder": "https://exemple.com/guide",
    "helpCenter.guidesSection.coverImageLabel": "Image de couverture",
    "helpCenter.guidesSection.coverPreviewAlt": "Aperçu de la couverture",
    "helpCenter.guidesSection.noGuides": "Aucun guide trouvé.",
    "helpCenter.guidesSection.addGuidePrompt": "Cliquez sur le bouton \"Ajouter un guide\" pour en créer un.",
    "helpCenter.guidesSection.viewGuide": "Voir le guide",
    "helpCenter.guidesSection.noLinkAvailable": "Aucun lien disponible",
    "chatWidget.errorConfigLoad": "Échec du chargement de la configuration du widget : ${response.status}",
    "chatWidget.openChatAriaLabel": "Ouvrir le chat",
    "chatWidget.avatarAlt": "Avatar",
    "chatWidget.moreOptionsAriaLabel": "Plus d'options",
    "chatWidget.closeAriaLabel": "Fermer",
    "chatWidget.fullscreenButton": "Plein écran",
    "chatWidget.resetButton": "Réinitialiser",
    "chatWidget.inputPlaceholder": "J'ai une question…",
    "chatWidget.sendButton": "ENVOYER",
    "chatWidget.normalScreenButton": "Quitter le mode plein écran",
    "chatWidget.welcomeMessage": "Comment puis-je vous aider aujourd'hui ?",
    "chatWidget.firstMessage": "Je suis un agent IA pour vous aider à trouver ce que vous cherchez !",
    "chatWidget.processError": "Désolé, je n'ai pas pu traiter votre demande.",
    "chatWidget.requestError": "Désolé, une erreur s'est produite lors du traitement de votre demande. Veuillez réessayer plus tard.",
    "chatWidget.copyButton": "Copier",
    "chatWidget.copiedButton": "Copié !"
  },
  "en": {
    "helpCenter.faqTab": "Frequently Asked Questions",
    "helpCenter.guidesTab": "Guides & SOPs",
    "helpCenter.forumTab": "Questions & Answers",
    "sideBar.appLogoAlt": "Prosomo",
    "sideBar.appName": "Prosomo",
    "sideBar.chatAgents": "Chat",
    "sideBar.chatAgentsTitle": "AI Chat Interface",
    "sideBar.chatAgentsSubtitle": "Interact with AI agents",
    "sideBar.dashboard": "Dashboard",
    "sideBar.dashboardTitle": "Analytics Dashboard",
    "sideBar.dashboardSubtitle": "View performance metrics",
    "sideBar.profile": "Profile",
    "sideBar.profileTitle": "User Profile",
    "sideBar.profileSubtitle": "Manage your account",
    "sideBar.widgets": "Widgets",
    "sideBar.widgetsTitle": "Custom Widgets",
    "sideBar.widgetsSubtitle": "Create and manage widgets",
    "sideBar.settings": "Settings",
    "sideBar.settingsTitle": "Application Settings",
    "sideBar.settingsSubtitle": "Configure your preferences",
    "sideBar.aiAgents": "AI Agents",
    "sideBar.aiAgentsTitle": "AI Agents Management",
    "sideBar.aiAgentsSubtitle": "Manage AI agent configurations",
    "sideBar.teamManagement": "Team Management",
    "sideBar.teamManagementTitle": "Team Management",
    "sideBar.teamManagementSubtitle": "Administer team settings",
    "sideBar.helpCenter": "Help Center",
    "sideBar.helpCenterTitle": "Help Center",
    "sideBar.helpCenterSubtitle": "Get support and resources",
    "sideBar.technicalSupport": "Technical Support",
    "sideBar.needHelp": "Need help?",
    "sideBar.contactSupport": "Contact Support",
    "sideBar.roleLabel": "Role:",
    "sideBar.idLabel": "ID:",
    "topBar.darkMode": "Dark Mode",
    "topBar.lightMode": "Light Mode",
    "topBar.userAvatarAlt": "User",
    "topBar.profile": "Profile",
    "topBar.logout": "Logout",
    "profilePage.profile": "Profile",
    "profilePage.subtitle": "Manage your personal information",
    "profilePage.personalInformation": "Personal Information",
    "profilePage.editProfile": "Edit Profile",
    "profilePage.profilePicture": "Profile Picture",
    "profilePage.uploadImage": "Upload Image",
    "profilePage.fullName": "Full Name",
    "profilePage.email": "Email",
    "profilePage.language": "Language",
    "profilePage.french": "French",
    "profilePage.english": "English",
    "profilePage.cancel": "Cancel",
    "profilePage.save": "Save",
    "profilePage.na": "N/A",
    "profilePage.profilePictureAlt": "Profile",
    "profilePage.invalidImageFile": "Please select a valid image file (PNG, JPG, GIF, or WebP)",
    "profilePage.imageSizeTooLarge": "Image must be less than 5MB",
    "profilePage.imageUrlError": "Failed to get public URL for uploaded image",
    "profilePage.uploadImageError": "Error uploading avatar image",
    "profilePage.profileUpdated": "Profile updated successfully",
    "profilePage.updateProfileError": "Error updating profile",
    "settings.generalPreferences": "General Preferences",
    "settings.language": "Language",
    "settings.french": "French",
    "settings.english": "English",
    "settings.save": "Save",
    "settings.platformManagement": "Platform Management",
    "settings.bucketError": "Storage buckets are not configured properly. Some image upload features may not work.",
    "settings.appLogo": "Application Logo",
    "settings.appLogoAlt": "App Logo",
    "settings.appLogoDescription": "Update the application logo that appears in the sidebar and throughout the platform. For best results, use a square image (1:1 ratio) with dimensions of at least 200x200 pixels.",
    "settings.uploadNewLogo": "Upload New Logo",
    "settings.logoChangeNote": "Changes will apply immediately after upload",
    "settings.defaultRequestEmail": "Default Request Email",
    "settings.defaultRequestEmailDescription": "Set the default email address where user requests will be sent when no agent-specific email is configured.",
    "settings.emailPlaceholder": "support@example.com",
    "settings.aiAgentImages": "AI Agent Images",
    "settings.aiAgentImagesNote": "💡 <strong>AI Agent images are now managed in the AI Agents Management section.</strong><br />Go to the \"AI Agents\" tab to upload and manage images for each individual agent.",
    "settings.appInfo": "About the Application",
    "settings.version": "Version: 1.0.0",
    "settings.platformDescription": "Internal AI Platform for Employees",
    "settings.developedWith": "Developed with React & Vite",
    "settings.cancel": "Cancel",
    "settings.edit": "Edit",
    "settings.languageUpdated": "Language updated successfully!",
    "settings.languageUpdateError": "Error updating language",
    "settings.invalidImageFile": "Please select an image file (PNG, JPG, GIF, or WebP)",
    "settings.imageSizeTooLarge": "Image must be less than 5MB",
    "settings.imageUrlError": "Failed to get public URL for uploaded file",
    "settings.logoUpdated": "Logo updated successfully!",
    "settings.logoUploadError": "Error uploading logo",
    "settings.invalidEmail": "Please enter a valid email address",
    "settings.emailUpdated": "Default request email updated successfully!",
    "settings.emailUpdateError": "Error updating email",
    "statistics.unknownUser": "Unknown User",
    "statistics.latestQuestionsError": "Failed to load latest questions",
    "statistics.analyticsError": "Failed to load analytics data",
    "statistics.loadingAnalytics": "Loading analytics...",
    "statistics.allTeams": "All Teams",
    "statistics.filters": "Filters",
    "statistics.clear": "Clear",
    "statistics.filterByAgents": "Filter by Agents",
    "statistics.searchUsers": "Search Users",
    "statistics.searchUsersPlaceholder": "Search by user name...",
    "statistics.totalMessages": "Total Messages (Selected Month)",
    "statistics.teamMessages": "Team Messages (Selected Month)",
    "statistics.allTeamsMessages": "All Teams Messages",
    "statistics.dailyMessages": "Daily Messages",
    "statistics.messages": "Messages",
    "statistics.topAgents": "Top AI Agents Used",
    "statistics.unknownAgent": "Agent {id}",
    "statistics.messagesCount": "{count} messages",
    "statistics.noAgentData": "No agent data for selected period",
    "statistics.recentChats": "Recent Chats",
    "statistics.noRecentChats": "No recent chats in selected period",
    "statistics.latestQuestions": "Latest Asked Questions",
    "statistics.loadingQuestions": "Loading latest questions...",
    "statistics.noRecentQuestions": "No recent questions yet",
    "statistics.user": "User",
    "statistics.agent": "Agent",
    "statistics.time": "Time",
    "statistics.status": "Status",
    "statistics.statusCompleted": "Completed",
    "teamManagement.accessDenied": "Access Denied",
    "teamManagement.accessDeniedMessage": "You don't have permission to access the Team Management page. Only users with the Administrator role can access this page.",
    "teamManagement.currentRole": "Current role:",
    "teamManagement.unknownRole": "Unknown",
    "teamManagement.refreshPermissions": "Refresh Permissions",
    "teamManagement.title": "Team Management",
    "teamManagement.subtitle": "Create a new team or select an existing one to manage members and settings. As an administrator, you can also manage all users and their roles.",
    "teamManagement.createNewTeam": "Create New Team",
    "teamManagement.inviteUser": "Invite User",
    "teamManagement.teams": "Teams",
    "teamManagement.loadingTeams": "Loading teams...",
    "teamManagement.noTeams": "No teams created yet",
    "teamManagement.createTeamTitle": "Create New Team",
    "teamManagement.teamName": "Team Name",
    "teamManagement.description": "Description",
    "teamManagement.allowedAgents": "Allowed AI Agents",
    "teamManagement.cancel": "Cancel",
    "teamManagement.createTeam": "Create Team",
    "teamManagement.inviteUserTitle": "Invite a new user",
    "teamManagement.fullName": "Full Name *",
    "teamManagement.fullNamePlaceholder": "John Doe",
    "teamManagement.emailAddress": "Email Address *",
    "teamManagement.emailPlaceholder": "john.doe@example.com",
    "teamManagement.role": "Role",
    "teamManagement.assignToTeams": "Assign to Teams * (Select at least one)",
    "teamManagement.noTeamsForInvite": "⚠️ You need to create at least one team before inviting users",
    "teamManagement.sendInvitation": "Send Invitation",
    "teamManagement.editUserTitle": "Edit User: {name}",
    "teamManagement.teamMemberships": "Team Memberships",
    "teamManagement.roleChangeWarning": "⚠️ Changing your own role may affect your access to certain features",
    "teamManagement.updateUser": "Update User",
    "teamManagement.addMembersTitle": "Add Members to {name}",
    "teamManagement.searchUsersPlaceholder": "Search users by name or email...",
    "teamManagement.noUsersFound": "No users found matching your search or all users are already in this team",
    "teamManagement.userAvatarAlt": "{name}",
    "teamManagement.addToTeam": "Add to Team",
    "teamManagement.manageTeamTitle": "Manage Team: {name}",
    "teamManagement.teamMembers": "Team Members",
    "teamManagement.allUsers": "All Users",
    "teamManagement.allUsersDescription": "Manage all users in the system",
    "teamManagement.inviteNewUser": "Invite New User",
    "teamManagement.actions": "Actions",
    "teamManagement.user": "User",
    "teamManagement.created": "Created",
    "teamManagement.editTeam": "Edit Team",
    "teamManagement.addMember": "Add Member",
    "teamManagement.deleteTeam": "Delete Team",
    "teamManagement.removeFromTeam": "Remove from team",
    "teamManagement.memberAvatarAlt": "{name}",
    "teamManagement.loadingTeamMembers": "Loading team members...",
    "teamManagement.noMembers": "No members in this team",
    "teamManagement.invitePrompt": "Use the invite button above to add users",
    "teamManagement.accountInformation": "Account Information",
    "teamManagement.email": "Email",
    "teamManagement.language": "Language",
    "teamManagement.french": "French",
    "teamManagement.english": "English",
    "teamManagement.na": "N/A",
    "teamManagement.administrator": "Administrator",
    "teamManagement.teamMember": "Team Member",
    "teamManagement.invitationIdError": "Failed to generate unique invitation ID after multiple attempts",
    "teamManagement.loadDataError": "Error loading data",
    "teamManagement.loadTeamMembersError": "Error loading team members",
    "teamManagement.loadTeamDetailsError": "Error loading team details",
    "teamManagement.loadUserDetailsError": "Error loading user details",
    "teamManagement.userUpdated": "User updated successfully",
    "teamManagement.updateUserError": "Error updating user",
    "teamManagement.teamCreated": "Team created successfully",
    "teamManagement.createTeamError": "Error creating team",
    "teamManagement.teamUpdated": "Team updated successfully",
    "teamManagement.updateTeamError": "Error updating team",
    "teamManagement.teamDeleted": "Team deleted successfully",
    "teamManagement.deleteTeamError": "Error deleting team",
    "teamManagement.inviteFormError": "Full name, email, and at least one team are required",
    "teamManagement.invitationSuccess": "Invitation sent successfully to {fullName} ({email})! The user will receive an email with:\n• Login instructions for the platform\n• Access to {teamCount} team(s): {teamNames}\n• Role assignment: {role}\nThe user account will be created automatically when they accept the invitation.",
    "teamManagement.invitationError": "Failed to send invitation. ",
    "teamManagement.invitationIdErrorDetails": "Could not generate a unique invitation ID. Please try again.",
    "teamManagement.networkError": "Network error occurred. Please check your connection and try again.",
    "teamManagement.serviceUnavailable": "The invitation service is temporarily unavailable. Please try again later.",
    "teamManagement.unknownError": "Unknown error occurred.",
    "teamManagement.userAlreadyInTeam": "User is already a member of this team",
    "teamManagement.userAddedToTeam": "User added to team successfully",
    "teamManagement.addUserToTeamError": "Error adding user to team",
    "teamManagement.removeUserConfirm": "Are you sure you want to remove this user from the team?",
    "teamManagement.userRemovedFromTeam": "User removed from team successfully",
    "teamManagement.removeUserError": "Error removing user from team",
    "teamManagement.deleteTeamConfirm": "Are you sure you want to delete this team? This action cannot be undone.",
    "teamManagement.updateTeam": "Update Team",
    "widgets.embedCode.title": "Embed Widget: {name}",
    "widgets.embedCode.description": "Copy this code and paste it into your website's HTML, just before the closing <code>&lt;/body&gt;</code> tag.",
    "widgets.embedCode.copied": "Copied!",
    "widgets.embedCode.copyToClipboard": "Copy to clipboard",
    "widgets.embedCode.copySuccess": "Widget embed code copied to clipboard",
    "widgets.embedCode.installationNotes": "Installation Notes:",
    "widgets.embedCode.positionNote": "The widget will appear as a chat button in the {position} corner of your website.",
    "widgets.embedCode.interactionNote": "Users can click on the button to open the chat interface.",
    "widgets.embedCode.autoOpenNote": "The widget will automatically open after {delay} seconds if enabled.",
    "widgets.embedCode.important": "Important:",
    "widgets.embedCode.allowedOriginsNote": "This widget will only work on the following domains:",
    "widgets.preview.title": "Widget Preview",
    "widgets.preview.headerTitle": "Sample Website",
    "widgets.preview.navHome": "Home",
    "widgets.preview.navAbout": "About",
    "widgets.preview.navServices": "Services",
    "widgets.preview.navContact": "Contact",
    "widgets.preview.mainTitle": "Welcome to Our Website",
    "widgets.preview.mainContent": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    "widgets.preview.featureOneTitle": "Feature One",
    "widgets.preview.featureOneContent": "Discover our innovative solutions designed to help you achieve your goals efficiently and effectively.",
    "widgets.preview.featureTwoTitle": "Feature Two",
    "widgets.preview.featureTwoContent": "Experience seamless integration with our cutting-edge technology for a smooth user experience.",
    "widgets.preview.footerText": "&copy; 2025 Sample Website. All rights reserved.",
    "widgets.preview.footerPrivacy": "Privacy Policy",
    "widgets.preview.footerTerms": "Terms of Service",
    "widgets.widgetForm.basicSettings": "Basic Settings",
    "widgets.widgetForm.widgetName": "Widget Name *",
    "widgets.widgetForm.widgetNamePlaceholder": "Customer Support Chat",
    "widgets.widgetForm.integrationType": "Integration Type",
    "widgets.widgetForm.aiAgent": "AI Agent",
    "widgets.widgetForm.customWebhook": "Custom Webhook",
    "widgets.widgetForm.webhookUrl": "Webhook URL *",
    "widgets.widgetForm.webhookUrlPlaceholder": "https://your-webhook-endpoint.com",
    "widgets.widgetForm.webhookRoute": "Webhook Route",
    "widgets.widgetForm.webhookRoutePlaceholder": "general",
    "widgets.widgetForm.isActive": "Active",
    "widgets.widgetForm.isActiveDescription": "When inactive, the widget won't be accessible on any website.",
    "widgets.widgetForm.allowedOrigins": "Allowed Origins",
    "widgets.widgetForm.allowedOriginsDescription": "Specify which websites can use this widget. Leave empty to allow all origins.",
    "widgets.widgetForm.originPlaceholder": "https://example.com",
    "widgets.widgetForm.removeOrigin": "Remove Origin",
    "widgets.widgetForm.addOrigin": "Add Origin",
    "widgets.widgetForm.appearance": "Appearance",
    "widgets.widgetForm.agentName": "Agent Name",
    "widgets.widgetForm.position": "Position",
    "widgets.widgetForm.positionBottomRight": "Bottom Right",
    "widgets.widgetForm.positionBottomLeft": "Bottom Left",
    "widgets.widgetForm.positionTopRight": "Top Right",
    "widgets.widgetForm.positionTopLeft": "Top Left",
    "widgets.widgetForm.primaryColor": "Primary Color",
    "widgets.widgetForm.autoOpenDelay": "Auto-Open Delay (seconds)",
    "widgets.widgetForm.autoOpenDelayDescription": "Time in seconds before the chat automatically opens. Set to 0 to disable.",
    "widgets.widgetForm.agentImageUrl": "Agent Image URL",
    "widgets.widgetForm.agentImagePlaceholder": "https://example.com/image.jpg",
    "widgets.widgetForm.agentImageDescription": "URL to the agent's avatar image (recommended size: 200x200px)",
    "widgets.widgetForm.agentImageAlt": "Agent",
    "widgets.widgetForm.welcomeMessage": "Welcome Message",
    "widgets.widgetForm.firstMessage": "First Message",
    "widgets.widgetForm.language": "Language",
    "widgets.widgetForm.french": "French",
    "widgets.widgetForm.english": "English",
    "widgets.widgetForm.cancel": "Cancel",
    "widgets.widgetForm.updateWidget": "Update Widget",
    "widgets.widgetForm.createWidget": "Create Widget",
    "widgets.widgetForm.selectAgent": "Select an agent",
    "widgets.widgetForm.welcomeMessageDefault": "How can I help you today?",
    "widgets.widgetForm.agentNameDefault": "AI Assistant",
    "widgets.widgetForm.firstMessageDefault": "I am an AI agent to help you find what you are looking for!",
    "widgets.widgetForm.selectAgentError": "Please select an agent",
    "widgets.widgetForm.updateSuccess": "Widget updated successfully",
    "widgets.widgetForm.createSuccess": "Widget created successfully",
    "widgets.widgetForm.saveError": "Failed to save widget.",
    "widgets.title": "Chat Widgets",
    "widgets.subtitle": "Create and manage chat widgets for your website",
    "widgets.createWidget": "Create Widget",
    "widgets.actions": "Actions",
    "widgets.name": "Name",
    "widgets.agent": "Agent",
    "widgets.status": "Status",
    "widgets.allowedOrigins": "Allowed Origins",
    "widgets.themePreview": "Theme Preview",
    "widgets.loadingWidgets": "Loading widgets...",
    "widgets.noWidgets": "No widgets found. Click \"Create Widget\" to get started.",
    "widgets.customWebhook": "Custom Webhook",
    "widgets.allOrigins": "All origins",
    "widgets.loadError": "Failed to load widgets. Please try again later.",
    "widgets.toggleStatusError": "Failed to update widget status. Please try again.",
    "widgets.activated": "Widget activated",
    "widgets.deactivated": "Widget deactivated",
    "widgets.deleteSuccess": "Widget deleted successfully",
    "widgets.deleteError": "Failed to delete widget. Please try again.",
    "widgets.deleteConfirm": "Are you sure you want to delete this widget? This action cannot be undone.",
    "widgets.moreActions": "More Actions",
    "widgets.copyEmbedCode": "Copy Embed Code",
    "widgets.deactivate": "Deactivate",
    "widgets.activate": "Activate",
    "widgets.editWidget": "Edit Widget",
    "widgets.deleteWidget": "Delete Widget",
    "agents.aiAssistant": "AI Assistant",
    "agents.statusOnline": "Online",
    "agents.noAgentsAvailable": "No AI agents available",
    "agents.noAgentsMessage": "No AI agents are available for this team. Contact your administrator to get access.",
    "agentsManagement.title": "AI Agents Management",
    "agentsManagement.subtitle": "Create, edit, and manage AI agents for your organization",
    "agentsManagement.addNewAgent": "Add New Agent",
    "agentsManagement.searchAgentsPlaceholder": "Search agents...",
    "agentsManagement.allTeams": "All Teams",
    "agentsManagement.loadingAgents": "Loading agents...",
    "agentsManagement.noAgentsCreated": "No AI agents created yet",
    "agentsManagement.noAgentsFound": "No agents found",
    "agentsManagement.createFirstAgentMessage": "Create your first AI agent to get started.",
    "agentsManagement.adjustSearchCriteria": "Try adjusting your search criteria.",
    "agentsManagement.totalAgents": "Total Agents",
    "agentsManagement.activeAgents": "Active Agents",
    "agentsManagement.teams": "Teams",
    "agentsManagement.accessDeniedTitle": "Access Denied",
    "agentsManagement.accessDeniedMessage": "You don't have permission to manage AI agents.",
    "agentsManagement.addNewAgentTitle": "Add New AI Agent",
    "agentsManagement.editAgentTitle": "Edit Agent",
    "agentsManagement.agentIdLabel": "Agent ID *",
    "agentsManagement.agentIdPlaceholder": "agent-id (auto-generated from name if empty)",
    "agentsManagement.agentNameLabel": "Agent Name *",
    "agentsManagement.agentNamePlaceholder": "e.g. Sales Assistant",
    "agentsManagement.descriptionLabel": "Description",
    "agentsManagement.descriptionPlaceholder": "Describe what this agent does...",
    "agentsManagement.apiEndpointLabel": "API Endpoint *",
    "agentsManagement.apiEndpointPlaceholder": "e.g. api/agents/sales-assistant",
    "agentsManagement.requestEmailLabel": "Request Email",
    "agentsManagement.requestEmailPlaceholder": "agent-specific@example.com",
    "agentsManagement.requestEmailDescription": "Email address for user requests related to this agent. If not specified, default email will be used.",
    "agentsManagement.teamAssignmentLabel": "Team Assignment",
    "agentsManagement.selectTeam": "Select Team",
    "agentsManagement.agentImageLabel": "Agent Image",
    "agentsManagement.agentPreviewAlt": "Agent preview",
    "agentsManagement.uploadImage": "Upload Image",
    "agentsManagement.setActiveLabel": "Set agent as active immediately",
    "agentsManagement.setActiveDescription": "If unchecked, agent will be created in 'In Training' mode",
    "agentsManagement.cancel": "Cancel",
    "agentsManagement.createAgent": "Create Agent",
    "agentsManagement.updateAgent": "Update Agent",
    "agentsManagement.defaultAgentsCreated": "Default agents created successfully",
    "agentsManagement.failedToCreateDefaultAgents": "Failed to create default agents",
    "agentsManagement.errorFetchingAgents": "Error fetching agents",
    "agentsManagement.invalidImageFile": "Please select a valid image file (PNG, JPG, GIF, or WebP)",
    "agentsManagement.imageSizeTooLarge": "Image must be less than 5MB",
    "agentsManagement.requiredFieldsMissing": "Name and API endpoint are required",
    "agentsManagement.agentCreated": "Agent created successfully",
    "agentsManagement.errorCreatingAgent": "Error creating agent",
    "agentsManagement.agentUpdated": "Agent updated successfully",
    "agentsManagement.errorUpdatingAgent": "Error updating agent",
    "agentsManagement.deleteAgentConfirm": "Are you sure you want to delete this agent? This action cannot be undone.",
    "agentsManagement.agentDeleted": "Agent deleted successfully",
    "agentsManagement.errorDeletingAgent": "Error deleting agent",
    "agentsManagement.statusActive": "Active",
    "agentsManagement.statusInactive": "Inactive",
    "agentsManagement.noDescription": "No description provided",
    "agentsManagement.createdAt": "Created",
    "agentsManagement.editAgent": "Edit Agent",
    "agentsManagement.deleteAgent": "Delete Agent",
    "agentsManagement.noAssignedTeams": "No assigned teams",
    "auth.resetEmailSent": "Check your inbox for a link to reset your password.",
    "auth.passwordsDoNotMatch": "Passwords do not match",
    "auth.registerSuccess": "Thanks for signing up! Please check your inbox and click the link to verify your email.",
    "auth.forgotPassword": "Forgot Password",
    "auth.register": "Register",
    "auth.login": "Login",
    "auth.fullName": "Full Name",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.confirmPassword": "Confirm Password",
    "auth.forgotPasswordLink": "Forgot your password?",
    "auth.backToLogin": "Back to login",
    "auth.sendResetLink": "Send Reset Link",
    "auth.signIn": "Sign In",
    "auth.alreadyHaveAccount": "Already have an account? Sign in",
    "auth.dontHaveAccount": "Don't have an account? Register",
    "auth.changePassword": "Change My Password",
    "auth.newPassword": "New Password",
    "auth.updateDescription": "Enter your new password. It must contain 8 to 15 alphanumeric characters with at least one special character.",
    "auth.cancel": "Cancel",
    "auth.updatePassword": "Update Password",
    "auth.invalidPasswordLength": "Password must be between 8 and 15 characters.",
    "auth.invalidPasswordFormat": "Password must be alphanumeric and contain at least one special character.",
    "auth.passwordUpdated": "Your password has been successfully updated.",
    "auth.recoveryDetected": "Please set a new password.",    
    "chatInterface.welcome": "Welcome to",
    "chatInterface.howCanIHelp": "How can I help you today?",
    "chatInterface.typing": "Typing...",
    "chatInterface.online": "Online",
    "chatInterface.agentDetails": "Agent details",
    "chatInterface.hideDetails": "Hide details",
    "chatInterface.showDetails": "Show details",
    "chatInterface.resetConversation": "Reset conversation",
    "chatInterface.reset": "Reset",
    "chatInterface.sessionIdLabel": "Session ID:",
    "chatInterface.descriptionLabel": "Description:",
    "chatInterface.teamAssignmentLabel": "Team Assignment:",
    "chatInterface.availableToAllTeams": "Available to all teams",
    "chatInterface.webhookLabel": "Webhook:",
    "chatInterface.noDescription": "No description provided",
    "chatInterface.responseProcessingError": "Received a response that could not be processed.",
    "chatInterface.technicalDifficulty": "Sorry, I'm experiencing technical difficulties. Please try again.",
    "chatInterface.copyResponse": "Copy response",
    "chatInterface.jumpToLatest": "Jump to latest",
    "chatInterface.sendRequestTitle": "Send a Request",
    "chatInterface.requestSentSuccess": "Request Sent Successfully!",
    "chatInterface.requestSentMessage": "We've received your request and will get back to you soon.",
    "chatInterface.yourNameLabel": "Your Name",
    "chatInterface.yourEmailLabel": "Your Email *",
    "chatInterface.emailRequired": "Email is required",
    "chatInterface.invalidEmail": "Please enter a valid email",
    "chatInterface.subjectLabel": "Subject *",
    "chatInterface.subjectRequired": "Subject is required",
    "chatInterface.messageLabel": "Message *",
    "chatInterface.messageRequired": "Message is required",
    "chatInterface.attachmentsLabel": "Attachments (Optional, max 10MB total)",
    "chatInterface.attachFiles": "Attach Files",
    "chatInterface.filesSelected": "{count} file(s) selected",
    "chatInterface.attachmentsSizeError": "Total file size cannot exceed 10MB",
    "chatInterface.sendRequest": "Send Request",
    "chatInterface.request": "Request",
    "chatInterface.typeMessage": "Type your message...",
    "chatInterface.send": "Send",
    "chatInterface.requestSubmitted": "Request submitted on {date}. A copy has been sent to {email}.",
    "chatInterface.copyButton": "Copy",
    "chatInterface.copiedButton": "Copied!",
    "guards.checkingPermissions": "Checking permissions...",
    "guards.accessDeniedTitle": "Access Denied",
    "guards.accessDeniedMessage": "You don't have permission to access this content.",
    "guards.currentRoleLabel": "Current role:",
    "guards.requiredPermissionLabel": "Required permission:",
    "guards.requiredPageAccessLabel": "Required page access:",
    "guards.refreshing": "Refreshing...",
    "guards.refreshPermissions": "Refresh Permissions",
    "helpCenter.faqSection.title": "Frequently Asked Questions",
    "helpCenter.faqSection.failedToLoad": "Failed to load FAQs. Please try again later.",
    "helpCenter.faqSection.deleteConfirm": "Are you sure you want to delete this FAQ?",
    "helpCenter.faqSection.deleteSuccess": "FAQ deleted successfully.",
    "helpCenter.faqSection.deleteFailed": "Failed to delete FAQ. Please try again.",
    "helpCenter.faqSection.requiredFields": "Title and content are required.",
    "helpCenter.faqSection.updateSuccess": "FAQ updated successfully.",
    "helpCenter.faqSection.createSuccess": "FAQ created successfully.",
    "helpCenter.faqSection.saveFailed": "Failed to save FAQ. Please try again.",
    "helpCenter.faqSection.addFaq": "Add FAQ",
    "helpCenter.faqSection.editFaqTitle": "Edit FAQ",
    "helpCenter.faqSection.addFaqTitle": "Add New FAQ",
    "helpCenter.faqSection.questionLabel": "Question",
    "helpCenter.faqSection.questionPlaceholder": "Enter the question",
    "helpCenter.faqSection.answerLabel": "Answer",
    "helpCenter.faqSection.answerPlaceholder": "Enter the answer",
    "helpCenter.faqSection.noFaqs": "No FAQs found.",
    "helpCenter.faqSection.addFaqPrompt": "Click the \"Add FAQ\" button to create one.",
    "helpCenter.forumSection.title": "Questions & Answers",
    "helpCenter.forumSection.failedToLoad": "Failed to load questions. Please try again later.",
    "helpCenter.forumSection.requiredFields": "Title and content are required.",
    "helpCenter.forumSection.submitSuccess": "Your question has been submitted successfully.",
    "helpCenter.forumSection.submitFailed": "Failed to submit question. Please try again.",
    "helpCenter.forumSection.answerRequired": "Answer is required.",
    "helpCenter.forumSection.answerSuccess": "Answer submitted successfully.",
    "helpCenter.forumSection.answerFailed": "Failed to submit answer. Please try again.",
    "helpCenter.forumSection.editQuestionSuccess": "Question updated successfully.",
    "helpCenter.forumSection.editQuestionFailed": "Failed to edit question. Please try again.",
    "helpCenter.forumSection.deleteQuestionConfirm": "Are you sure you want to delete this question?",
    "helpCenter.forumSection.deleteQuestionSuccess": "Question deleted successfully.",
    "helpCenter.forumSection.deleteQuestionFailed": "Failed to delete question. Please try again.",
    "helpCenter.forumSection.editAnswerSuccess": "Answer updated successfully.",
    "helpCenter.forumSection.editAnswerFailed": "Failed to edit answer. Please try again.",
    "helpCenter.forumSection.deleteAnswerConfirm": "Are you sure you want to delete this answer?",
    "helpCenter.forumSection.deleteAnswerSuccess": "Answer deleted successfully.",
    "helpCenter.forumSection.deleteAnswerFailed": "Failed to delete answer. Please try again.",
    "helpCenter.forumSection.askQuestion": "Ask a Question",
    "helpCenter.forumSection.newQuestionTitle": "Ask a New Question",
    "helpCenter.forumSection.titleLabel": "Title *",
    "helpCenter.forumSection.titlePlaceholder": "Summarize your question",
    "helpCenter.forumSection.contentLabel": "Question Details *",
    "helpCenter.forumSection.contentPlaceholder": "Provide details about your question",
    "helpCenter.forumSection.submitQuestion": "Submit Question",
    "helpCenter.forumSection.editQuestionTitle": "Edit Question",
    "helpCenter.forumSection.saveChanges": "Save Changes",
    "helpCenter.forumSection.noQuestions": "No questions found. Be the first to ask a question!",
    "helpCenter.forumSection.statusAnswered": "Answered",
    "helpCenter.forumSection.statusOpen": "Open",
    "helpCenter.forumSection.answerFrom": "Answer from:",
    "helpCenter.forumSection.admin": "Admin",
    "helpCenter.forumSection.answerLabel": "Your Answer *",
    "helpCenter.forumSection.answerPlaceholder": "Type your answer here...",
    "helpCenter.forumSection.answerQuestion": "Answer This Question",
    "helpCenter.guidesSection.title": "Guides & SOPs",
    "helpCenter.guidesSection.failedToLoad": "Failed to load guides. Please try again later.",
    "helpCenter.guidesSection.deleteConfirm": "Are you sure you want to delete this guide?",
    "helpCenter.guidesSection.deleteSuccess": "Guide deleted successfully.",
    "helpCenter.guidesSection.deleteFailed": "Failed to delete guide. Please try again.",
    "helpCenter.guidesSection.titleRequired": "Title is required.",
    "helpCenter.guidesSection.updateSuccess": "Guide updated successfully.",
    "helpCenter.guidesSection.createSuccess": "Guide created successfully.",
    "helpCenter.guidesSection.saveFailed": "Failed to save guide. Please try again.",
    "helpCenter.guidesSection.addGuide": "Add Guide",
    "helpCenter.guidesSection.editGuideTitle": "Edit Guide",
    "helpCenter.guidesSection.addGuideTitle": "Add New Guide",
    "helpCenter.guidesSection.titleLabel": "Title *",
    "helpCenter.guidesSection.titlePlaceholder": "Enter the guide title",
    "helpCenter.guidesSection.descriptionLabel": "Description",
    "helpCenter.guidesSection.descriptionPlaceholder": "Enter a brief description",
    "helpCenter.guidesSection.externalLinkLabel": "External Link",
    "helpCenter.guidesSection.urlPlaceholder": "https://example.com/guide",
    "helpCenter.guidesSection.coverImageLabel": "Cover Image",
    "helpCenter.guidesSection.coverPreviewAlt": "Cover preview",
    "helpCenter.guidesSection.noGuides": "No guides found.",
    "helpCenter.guidesSection.addGuidePrompt": "Click the \"Add Guide\" button to create one.",
    "helpCenter.guidesSection.viewGuide": "View Guide",
    "helpCenter.guidesSection.noLinkAvailable": "No link available",
    "chatWidget.errorConfigLoad": "Failed to load widget config: ${response.status}",
    "chatWidget.openChatAriaLabel": "Open the chat",
    "chatWidget.avatarAlt": "Avatar",
    "chatWidget.moreOptionsAriaLabel": "More options",
    "chatWidget.closeAriaLabel": "Close",
    "chatWidget.fullscreenButton": "Fullscreen",
    "chatWidget.resetButton": "Reset",
    "chatWidget.inputPlaceholder": "I have a question…",
    "chatWidget.sendButton": "SEND",
    "chatWidget.normalScreenButton": "Exit fullscreen",
    "chatWidget.welcomeMessage": "How can I help you today?",
    "chatWidget.firstMessage": "I am an AI agent to help you find what you're looking for!",
    "chatWidget.processError": "I'm sorry, I couldn't process your request.",
    "chatWidget.requestError": "I'm sorry, there was an error processing your request. Please try again later.",
    "chatWidget.copyButton": "Copy",
    "chatWidget.copiedButton": "Copied!"   
  }
}

export const useTranslation = (language = 'fr') => {
  return (key, defaultValue = "") => translations[language][key] || defaultValue || key;
};